import canOpenApp from './canOpenApp';

export default canOpenApp;
